import { axiosInstance } from "../../../config/api/Axios";

export const getAllByFilter = (params) => axiosInstance.get("/common/cities", {
        params,
    });
